module.exports = __webpack_public_path__ + "130a3907b1b872f554cc897ad767aa70.svg";